import WMTSLayer from '@arcgis/core/layers/WMTSLayer';
import PropTypes from 'prop-types';

/**
 * Create a WMTS (Web Map Tile Services) layer instance from a service url and active layer id.
 * https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-WMTSLayer.html
 * @param {String} url - GIS WMTS service url
 * @param {String} layerName - Name of the WMTS active layer to be displayed on the map
 * @param {Object} wmtsLayerProps - Additional WMS layer properties that can be passed, check the
 * documentation for a list of all the properties that may be passed into the constructor
 */
export const createWMTSLayer = async ({ url, layerName, ...wmtsLayerProps }) =>
  await handleWMTSLayer({ url, layerName, ...wmtsLayerProps });

async function handleWMTSLayer({ url, layerName, ...wmtsLayerProps }) {
  const wmtsLayer = new WMTSLayer({
    url,
    activeLayer: {
      id: layerName,
    },
    ...wmtsLayerProps,
  });

  // Layer must be loaded so that layer properties can be queried.
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-WMTSLayer.html#load
  await wmtsLayer.load();

  // TODO: Wait for feedback from the product team on WMTS layer error handling.
  // Intercepts the WMTS API requests and check for errors. This can occur when the user is viewing
  // an area on the map where the web map images are unavailable.
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-config.html#RequestInterceptor
  // esriConfig.request.interceptors.push({
  //   urls: url,
  //   error: error => {
  //     console.log('WMTS API request error', error);
  //   },
  // });

  return wmtsLayer;
}

createWMTSLayer.PropType = {
  url: PropTypes.string.isRequired,
  layerName: PropTypes.string.isRequired,
};
